
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Dropdown, Divider, Form, Dimmer, TextArea, Table,  Button, Grid,Input, Radio, List, Popup, Icon, Segment, Image} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PreguntaForm=({ id, color, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos,  onChangeMultiple, agregarOpcion, onEditar,  onBorrar, opcion, respuestas, tipoRespuesta, tipoPregunta, onChangeFile, onSaveImangenR, onCorrecto, onHandleFile, deleteImagenPregunta})=>{

    
	return (
        
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                           
                                            
                            <Form.Field  required  error={errors.nombre}>            
                              <label  >{strings?strings["question"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["question"]:""} 
                                    name="nombre"
                                    onChange={onChange}
                                    value={datos.nombre}
                                    icon='edit'/>
                            </Form.Field>
                                        
        
                            <Form.Field  required  error={errors.point}>            
                              <label  >{strings?strings["point"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["point"]:""} 
                                    name="point"
                                    onChange={onChange}
                                    value={datos.point}
                                    icon='edit'/>
                            </Form.Field>
        
        
                             <Form.Field  required  error={errors.explanation}>            
                              <label  >{strings?strings["explanation"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["explanation"]:""} 
                                    name="explanation"
                                    onChange={onChange}
                                    value={datos.explanation}
                                    icon='edit'/>
                            </Form.Field>
        
                            
                            <Form.Field  required  error={errors.messageForCorrectAnswer}>            
                              <label  >{strings?strings["messageForCorrect"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["messageForCorrect"]:""} 
                                    name="messageForCorrect"
                                    onChange={onChange}
                                    value={datos.messageForCorrect}
                                    icon='edit'/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.messageForIncorrectAnswer}>            
                              <label  >{strings?strings["messageForIncorrect"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["messageForIncorrect"]:""} 
                                    name="messageForIncorrect"
                                    onChange={onChange}
                                    value={datos.messageForIncorrect}
                                    icon='edit'/>
                            </Form.Field>
            
                            <Form.Field  required  error={errors.questionType}>            
                              <label  >{strings?strings["questionType"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["questionType"]:""} 
                                    name="questionType"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.questionType}
                                    options={tipoPregunta}/>
                            </Form.Field>
        
        
        
                            <Form.Field  required  error={errors.answerSelectionType}>            
                              <label  >{strings?strings["answerSelectionType"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["answerSelectionType"]:""} 
                                    name="answerSelectionType"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.answerSelectionType}
                                    options={tipoRespuesta}/>
                            </Form.Field>
                            
                            <Form.Field  >
                            <label>{strings?strings["nuevafoto"]:""} </label>
                             <Input placeholder='questionPic'
                                onChange={onHandleFile}
                                name="questionPic"
                                type='file'

                            />        
                            </Form.Field>
        
                            {datos.preguntaImagen!=null?    
                                <>
                                <Image  src={datos.preguntaImagen} />    

                                <Button style={{background: '#255b4d' , color:"white"}} onClick={deleteImagenPregunta}>
                                    Borrar imagen
                                </Button>
                                </>
                            :
                    
                                ""
        
                            }
                           
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
             {datos.id?
            <>
                <Grid.Row color={opcion.id>0?"grey":""}>
                    
                    <Grid.Column width={12}>
                       
                        {datos.questionType=="text"?
        
                            <Input
                                fluid
                                label="Opción"
                                name="texto1"
                                onChange={onChangeMultiple}
                                value={opcion.texto1}
                                placeholder='Captura las respuestas que requiera para la pregunta' />

                            :
        
                            <Form.Field  >
                            <label>{strings?strings["nuevafoto"]:""} </label>
                             <Input placeholder='Imagen'
                                onChange={onChangeFile}
                                name="texto1"
                                type='file'

                            />        
                            </Form.Field>
        
                        }
                        
                    </Grid.Column>
                    <Grid.Column >                
                         <label  >Correcta </label>
                          <Radio 
                                slider
                                name="correctAnswer"
                                checked={opcion.correctAnswer==1? true:false}
                                onChange={onChangeMultiple}/>
                    </Grid.Column>
                    <Grid.Column >
        
                        {datos.questionType=="text"?
        
                            <Button style={{background: '#255b4d' , color:"white"}} onClick={agregarOpcion}>
                                {opcion.id>0?"Actualizar":"Agregar"}
                            </Button>
                            :
                            <Button style={{background: '#255b4d' , color:"white"}} onClick={onSaveImangenR}>
                                {opcion.id>0?"Actualizar":"Agregar"}
                            </Button>
                        }
                    </Grid.Column>
                
              </Grid.Row>
        
             
        
                <Grid.Row columns={1}>
                                    <Grid.Column >
                                    <Table compact celled >
                                        <Table.Header>
                                          <Table.Row>
                                            <Table.HeaderCell>Opciones</Table.HeaderCell>
                                            <Table.HeaderCell>Correcto</Table.HeaderCell>    
                                            <Table.HeaderCell textAlign="center">Acción</Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>
                                      
                                        {respuestas.map(dato =>
        
                                       <Table.Row>  
                                            <Table.Cell>
                                                 {datos.questionType=="text"?
                                                            <>
                                                            {dato.texto1}
                                                            </>
                                                    :
                                                    <img  src={dato.texto1} alt="" />
                                                }
        
                                            </Table.Cell>
                                            <Table.Cell> {dato.correctAnswer==1?"Respuesta correcta":""}</Table.Cell>
                                            <Table.Cell textAlign="center">
                                                <List horizontal>
                                                     {datos.questionType=="text"?
                                                        <List.Item>
                                                           <Popup
                                                                trigger={
                                                                    <Icon name='edit outline' link 
                                                                    onClick={()=>onEditar(dato.id)} 
                                                                    size="large" color="teal"  />
                                                                }
                                                                content='Editar'                                       
                                                              />
                                                        </List.Item>
                                                    :
                                                        ""
                                                    }
                                                    <List.Item>
                                                       <Popup
                                                            trigger={
                                                                <Icon name='trash alternate outline' link 
                                                                onClick={()=>onBorrar(dato.id)} 
                                                                size="large" color="red"  />
                                                            }
                                                            content='Borrar'                                       
                                                          />
                                                    </List.Item>
                                                            
                                                    <List.Item>
                                                       <Popup
                                                            trigger={
                                                                <Icon name={dato.correctAnswer==1?"thumbs up outline":"thumbs down outline"} link 
                                                                onClick={()=>onCorrecto(dato.id)} 
                                                                size="large" color={dato.correctAnswer==1?"green":"red"}  />
                                                            }
                                                            content={dato.correctAnswer==1?"Cambiar a incorrecta":"Cambiar a correcta"}                                       
                                                          />
                                                    </List.Item>        
                                                            
                                                </List>
                                            </Table.Cell>
                                        </Table.Row>
                    
                                        )}
        
        
                                    
                                </Table> 
                                </Grid.Column>
                </Grid.Row>
            </>                    
                :
                ""
                }
              <Grid.Row >
                        <Grid.Column>
                            <Grid centered>
                            <Button.Group  >
                                <Link to="/examens">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                              </Grid>
                            <br/><br/>
        
                        </Grid.Column>
                </Grid.Row>
            
        </Grid>
        
        
        
	);
};



export default PreguntaForm;